import React,{useEffect} from 'react'
import { Col, Row, Typography } from 'antd'
import './circle.css'

const CountCircle = (props) => {
    const {Text} = Typography


    return (
        <>
        <Row className='count-seeAll-row'>
        { props.count?
            <Col xs={5}>
                <div className='circle'>
                {props.count}
                </div>
            </Col>
            :null
        }
        </Row>
        </>
    )

}
export default CountCircle;